import { useEffect, useState } from 'react';
import { oneliveAssets } from './assets';
import { navigate, navigateToMypageHub } from './api';

const TABS = [
  {
    key: 'rooms',
    label: '방리스트',
    path: '/chat',
    icon: oneliveAssets.navHome,
    isActive: (path: string) => path === '/chat' || path.startsWith('/chat/'),
  },
  {
    key: 'shop',
    label: '아이템샵',
    path: '/shop',
    icon: oneliveAssets.navItem,
    isActive: (path: string) => path === '/shop' || path.startsWith('/shop/'),
  },
  {
    key: 'live',
    label: '라이브',
    path: '/',
    icon: oneliveAssets.navLive,
    isActive: (path: string) => path === '/' || path === '/live' || path.startsWith('/live/'),
  },
  {
    key: 'profile',
    label: '개인정보',
    path: '/mypage/profile',
    icon: oneliveAssets.navUser,
    isActive: (path: string) => path.startsWith('/mypage')
      || path === '/login'
      || path === '/register'
      || path.startsWith('/forgot-password')
      || path.startsWith('/reset-password'),
  },
] as const;

function readPath() {
  return window.location.pathname.replace(/\/$/, '') || '/';
}

export default function OneliveMobileNav() {
  const [path, setPath] = useState(readPath);

  useEffect(() => {
    const onNav = () => setPath(readPath());
    window.addEventListener('popstate', onNav);
    const tm = window.setInterval(onNav, 500);
    return () => {
      window.removeEventListener('popstate', onNav);
      window.clearInterval(tm);
    };
  }, []);

  return (
    <nav className="onelive-mobile-bottom-nav" aria-label="모바일 하단 메뉴">
      <ul className="onelive-mobile-bottom-nav-list">
        {TABS.map((tab) => {
          const active = tab.isActive(path);
          return (
            <li key={tab.key}>
              <button
                type="button"
                className={`onelive-mobile-bottom-nav-item${active ? ' active' : ''}`}
                onClick={() => {
                  if (tab.key === 'profile') {
                    navigateToMypageHub();
                    return;
                  }
                  navigate(tab.path);
                }}
              >
                <span className="onelive-mobile-bottom-nav-icon" aria-hidden>
                  <img src={tab.icon} alt="" width={22} height={22} />
                </span>
                <em>{tab.label}</em>
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
